import React from 'react';
import c from 'classnames';
import { Props as IconProps, IconSize } from '../../../../Icons/IconWrap';
import commonStyles from '../../common.scss';
import s from './ListItemContent.scss';

export interface Props {
  label: React.ReactNode;
  subLabel?: React.ReactNode;
  prefix?: React.ReactNode;
  prefixIcon?: React.ComponentType<IconProps>;
  suffix?: React.ReactNode;
  suffixIcon?: React.ComponentType<IconProps>;
  bottomSlot?: React.ReactNode;
  backgroundImage?: React.ReactNode;
  isLabelBold?: boolean;
  isDim?: boolean;
  isDangerous?: boolean; // DS6.1.4
  biggerPaddings?: boolean; // DS6.1.10
  onClick?: (ev: React.MouseEvent) => void;
  onLabelClick?: (ev: React.MouseEvent) => void;
  onPrefixClick?: (ev: React.MouseEvent) => void;
}

const ListItemContent: React.FC<Props> = ({
  prefix,
  prefixIcon: PrefixIcon,
  label,
  subLabel,
  suffix,
  suffixIcon: SuffixIcon,
  bottomSlot,
  backgroundImage,
  isLabelBold,
  isDim,
  isDangerous,
  biggerPaddings,
  onClick,
  onLabelClick,
  onPrefixClick,
}) => {
  return (
    <div
      className={c(
        s['root'],
        isDim && s['dim'],
        isDangerous && s['dangerous'],
        biggerPaddings && s['padded']
      )}
      onClick={onClick}
    >
      {backgroundImage && (
        <div className={s['background-image']}>{backgroundImage}</div>
      )}
      {/* TODO: Update div to PlainButtonOrLink when onClick is present. (T64085) */}
      <div className={c(s['main-content-grid'], !!prefix && s['has-prefix'])}>
        {(prefix || PrefixIcon) && (
          <div className={s['prefix']} onClick={onPrefixClick}>
            {/* TODO: Update div to PlainButtonOrLink when onPrefixClick is present / see T64085 */}
            {prefix}
            {PrefixIcon && (
              <PrefixIcon size={IconSize.MEDIUM} disableDefaultColors={true} />
            )}
          </div>
        )}
        <div className={s['central-area']} onClick={onLabelClick}>
          {/* TODO: Update div to PlainButtonOrLink when onLabelClick is present / see T64085 */}
          <div className={c(s['label'], isLabelBold && s['bold-label'])}>
            {label}
          </div>
          {subLabel &&
            (typeof subLabel === 'string' ? (
              <div className={s['sub-label']}>{subLabel}</div>
            ) : (
              subLabel
            ))}
        </div>
        {(suffix || SuffixIcon) && (
          <div className={c(s['suffix'], commonStyles['suffix'])}>
            {suffix}
            {SuffixIcon && (
              <SuffixIcon
                size={IconSize.MEDIUM}
                className={c(s['suffix'], commonStyles['suffix'])}
                disableDefaultColors={true}
              />
            )}
          </div>
        )}
      </div>

      {bottomSlot && <div className={s['bottom-slot']}>{bottomSlot}</div>}
    </div>
  );
};

ListItemContent.displayName = 'ListItemContent';

export default ListItemContent;
